export const TOGGLE_SELECTED = 'TOGGLE_SELECTED';
export const UNSELECT_ALL = 'UNSELECT_ALL';
export const OPEN_REWARDS_GRID = 'OPEN_REWARDS_GRID';
export const CLOSE_REWARDS_GRID = 'CLOSE_REWARDS_GRID';
export const SHOW_ROULETTE = 'SHOW_ROULETTE';
export const CLOSE_ROULETTE = 'CLOSE_ROULETTE';



/** WEBPACK FOOTER **
 ** ./src/constants/actionTypes.js
 **/